export const scrollToTop = (ref) => {

  // Avoid Firefox open pages to the bottom
  function isFuncNative(f) {
    return !!f && (typeof f).toLowerCase() == 'function'
    && (f === Function.prototype
    || /^\s*function\s*(\b[a-z$_][a-z0-9$_]*\b)*\s*\((|([a-z$_][a-z0-9$_]*)(\s*,[a-z$_][a-z0-9$_]*)*)\)\s*{\s*\[native code\]\s*}\s*$/i.test(String(f)));
  }

  function myScroll(left, top) {
    if (isFuncNative(window.scrollTo)) {
        window.scrollTo({left: left, top: top, behavior: 'smooth'});
    } else if (isFuncNative(window.scroll)) {
        window.scroll({left: left, top: top, behavior: 'smooth'});
    } else {
        document.body.scrollLeft = left;
        document.body.scrollTop = top;
    }
  }

  myScroll(0,0);


  return scrollToTop;
}
